import React from 'react';
import PropTypes from 'prop-types';
import ImgWithText from './ImgWithText'
import LazyLoad from 'react-lazyload';

import { StyledUnaccompaniedImageWrapper, StyledUnaccompaniedImage, StyledFigCaption } from './styled'

const ImageWithText = ({ data, preview, language }) => {
  return (
    <React.Fragment>
      {data.items.map(el => {

        const altText = el.inset_image.alt || "";
        
        const imageHeight = el.inset_image.dimensions.height;
        // const imageWidth = el.inset_image.dimensions.width;
        
        const alignImage = el?.align_image || "center";
        const customWidth = el?.custom_width || "initial";

        const richTxt = preview ? el.richtext : el.richtext.raw;
        const insetImgWithText = richTxt !== null && richTxt.length > 0 && richTxt.filter(item => item.text.trim() !== "");

        if (insetImgWithText.length > 0) {
          return (
            <ImgWithText 
              altText={altText}
              key={el.inset_image.url}
              el={el} 
              preview={preview}
              language={language}
            />
          )
        } else {

          if (el.inset_image) {
            return (
              <StyledUnaccompaniedImageWrapper alignImage={alignImage}>
                <LazyLoad 
                  offset={100} 
                  once={true} 
                  height={imageHeight}
                  placeholder={ <img data-src={el.inset_image.url} data-alt={altText} /> }
                  style={`width: ${customWidth === 'full width' ? '100%' : customWidth};`}
                >
                  <StyledUnaccompaniedImage 
                    alt={altText}
                    key={el.inset_image.url}
                    src={el.inset_image.url}
                    style={{width: `${customWidth === 'full width' ? '100%' : customWidth}`}}
                    hasCaption={el.image_caption}
                  />
                  {el.image_caption && <StyledFigCaption> {el.image_caption} </StyledFigCaption> }
                </LazyLoad>
              </StyledUnaccompaniedImageWrapper>
            )
          }

        }
      })}
    </React.Fragment>
  );
};

  ImageWithText.propTypes = {
    data: PropTypes.object,
    language: PropTypes.string,
    preview: PropTypes.bool
  };

export default ImageWithText;

